import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './Providers';
import { createRouter } from './routes';

export function App() {
  const [router] = useState(createRouter);
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
